import ModuleList from '@/components/module/ModuleList.vue';
import SectorList from '@/components/module/SectorList.vue';
import ThemeDetails from '@/components/module/ThemeDetails.vue';
import ThemeList from '@/components/module/ThemeList.vue';
import TopicList from '@/components/module/TopicList.vue';
import HUBApi from '@/service/hub-api';
import HUBStore from '@/store';
import HUBLog from '@/utils/logger';
import HUBValidation from '@/utils/validation';

/**
 * Module related pages
 */

const learningRouter = {
  routes: [
    {
      /** Sector list page */
      path: '/sectors/l/:learningTypeId',
      name: 'sectorList',
      component: SectorList,
    },
    {
      /** Theme list page */
      path: '/themes/s/:sectorId',
      name: 'themeList',
      component: ThemeList,
    },
    {
      /** Theme details page */
      path: '/themes/:listThemeId',
      name: 'themeDetails',
      component: ThemeDetails,
    },
    {
      /** Topic list page */
      path: '/topics/th/:themeId',
      name: 'topicList',
      component: TopicList,
    },
    {
      /** Module list page */
      path: '/modules/t/:topicId',
      name: 'moduleList',
      component: ModuleList,
    },
  ],
};

learningRouter.routes.forEach((r) => {
  const route = r;
  route.props = true;
});

learningRouter.guard = async (to, from) => {
  // Not a learning page
  // Pass to next guard
  if (!HUBValidation.validateRoute(to.name, learningRouter.routes)) {
    return;
  }

  const { learningTypeId } = to.params;
  const { sectorId } = to.params;
  const { listThemeId } = to.params;
  const { themeId } = to.params;
  const { topicId } = to.params;

  const results = {};
  const HUBSettingItems = {};

  // Get current learning for learning pages
  if (learningTypeId) {
    results.learning = await HUBApi.get(`/learning-types/${learningTypeId}`);
  } else if (sectorId) {
    results.learning = await HUBApi.get(`/learning-types/sector/${sectorId}`);
  } else if (listThemeId) {
    results.learning = await HUBApi.get(`/learning-types/theme/${listThemeId}`);
  } else if (themeId) {
    results.learning = await HUBApi.get(`/learning-types/theme/${themeId}`);
  } else if (topicId) {
    results.learning = await HUBApi.get(`/learning-types/topic/${topicId}`);
  }

  // Current learning is unavailable
  if (
    !results.learning ||
    !results.learning.records ||
    !results.learning.records[0] ||
    results.learning.records[0].learning_type_status !== 'available'
  ) {
    HUBLog.debug(`Back to: ${from.path}`);
    throw new Error('$Reject');
  }

  // Set current learning for paes
  [HUBSettingItems.currentLearningType] = results.learning.records;

  // Set other data for pages
  if (learningTypeId) {
    HUBSettingItems.levelUp = { name: 'dashboard' };
  } else if (sectorId) {
    HUBSettingItems.levelUp = {
      name: 'sectorList',
      params: { learningTypeId: HUBSettingItems.currentLearningType.id },
    };
  } else if (listThemeId) {
    results.theme = await HUBApi.get(`/themes/${listThemeId}`);

    if (!results.theme || !results.theme.records || !results.theme.records[0]) {
      HUBLog.debug(`Back to: ${from.path}`);
      throw new Error('$Reject');
    }

    [HUBSettingItems.currentTheme] = results.theme.records;
    HUBSettingItems.levelUp = {
      name: 'themeList',
      params: { sectorId: HUBSettingItems.currentTheme.sector_id },
    };
  } else if (themeId) {
    results.theme = await HUBApi.get(`/themes/${themeId}`);

    if (!results.theme || !results.theme.records || !results.theme.records[0]) {
      HUBLog.debug(`Back to: ${from.path}`);
      throw new Error('$Reject');
    }

    [HUBSettingItems.currentTheme] = results.theme.records;
    HUBSettingItems.levelUp = {
      name: 'themeDetails',
      params: { listThemeId: HUBSettingItems.currentTheme.id },
    };
  } else if (topicId) {
    results.theme = await HUBApi.get(`/themes/topic/${topicId}`);

    if (!results.theme || !results.theme.records || !results.theme.records[0]) {
      HUBLog.debug(`Back to: ${from.path}`);
      throw new Error('$Reject');
    }

    [HUBSettingItems.currentTheme] = results.theme.records;
    HUBSettingItems.levelUp = {
      name: 'topicList',
      params: { themeId: HUBSettingItems.currentTheme.id },
    };
  }

  HUBStore.commit('setHUBSettingItems', {
    ...HUBSettingItems,
    currentFunction: {
      key: HUBSettingItems.currentLearningType.learning_type_key,
      name: HUBSettingItems.currentLearningType.name,
    },
  });

  HUBLog.debug(`Access: ${to.path}`);
  throw new Error();
};

export default learningRouter;
